import React from 'react';

const TelLabel = () => (
<svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M3.78296 0.826921C4.9837 -0.37382 6.96512 -0.250462 8.00765 1.08994L10.9099 4.82136C11.4425 5.50612 11.6307 6.39771 11.4203 7.2393L10.5348 10.7812C10.4413 11.1551 10.5509 11.5507 10.8234 11.8232L14.7982 15.798C15.0707 16.0705 15.4663 16.1801 15.8402 16.0866L19.3821 15.2011C20.2237 14.9907 21.1153 15.1789 21.8 15.7115L25.5315 18.6138C26.8719 19.6563 26.9952 21.6377 25.7945 22.8384L24.1216 24.5113C22.9247 25.7082 21.1346 26.2337 19.4662 25.6472C15.3238 24.1908 11.4355 21.8064 8.12521 18.4962C4.81496 15.1859 2.4306 11.2976 0.974218 7.1552C0.38766 5.48684 0.913207 3.69668 2.11007 2.49981L3.78296 0.826921Z" fill="#141414"/>
</svg>
);

export default TelLabel;
